import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { allowedRechargeUsers } from 'src/constants/wallet'
import { IRefundTransactionDTO, IRiderObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import WalletTransactionItem from './WalletTransactionListItem'
import classNames from 'classnames'

interface IWalletTransactionListProps {
  rider: IRiderObject
  timeFormat: string
  currentUserId: string
  path: string
  assignRefundDetails: (params: IRefundTransactionDTO) => void
}

class WalletTransactionList extends React.Component<IWalletTransactionListProps, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      refundDetails: {}
    }
  }

  public render() {
    const { rider } = this.props
    return (
      <div
        className={classNames('wallet-transaction-list-table', {
          'min-w99 border-light-grey4': rider && rider.walletTransactions && rider.walletTransactions.length === 0
        })}
      >
        {rider && rider.walletTransactions && rider.walletTransactions.length > 0 && (
          <>
            <div className='flex'>
              <div className='col-2'>
                <span className='h5 font-grey2'>{UIMessages.common.date}</span>
              </div>
              <div className='col-4'>
                <span className='h5 font-grey2'>{UIMessages.common.transactionId}</span>
              </div>
              <div className='col-1'>
                <span className='h5 font-grey2'>{UIMessages.common.tripId}</span>
              </div>
              <div className='col-1'>
                <span className='h5 font-grey2'>{UIMessages.common.type}</span>
              </div>
              <div className='col-2'>
                <span className='h5 font-grey2'>{UIMessages.common.paymentMethod}</span>
              </div>
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.net}</span>
              </div>
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.amount} </span>
              </div>
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.fee} </span>
              </div>
              {this.allowUserToRecharge() && (
                <div className='col-1'>
                  <span className='h5 font-grey2'>{UIMessages.common.recharge} </span>
                </div>
              )}
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.refund}</span>
              </div>
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.balance}</span>
              </div>
              <div className='col-3'>
                <span className='h5 font-grey2'>{UIMessages.common.transactionMessage}</span>
              </div>
              <div className='col-2'>
                <span className='h5 font-grey2'>{UIMessages.common.transactionInitiator}</span>
              </div>
            </div>
            <div className='bt-light-grey4'>&nbsp;</div>
          </>
        )}
        {rider &&
          rider.walletTransactions &&
          Object.keys(rider.walletTransactions).map((item, i) => (
            <WalletTransactionItem
              key={`tmli-${i}`}
              transaction={rider.walletTransactions[item]}
              timeFormat={this.props.timeFormat}
              currentUserId={this.props.currentUserId}
              riderId={rider.id}
              path={this.props.path}
              assignRefundDetails={this.props.assignRefundDetails}
              isRechargeAllowed={this.allowUserToRecharge()}
            />
          ))}
        {rider && rider.walletTransactions && rider.walletTransactions.length === 0 && (
          <div className='p3 m3 flex items-center justify-center h5 font-grey2'>No Existing Wallet Transactions</div>
        )}
      </div>
    )
  }

  private allowUserToRecharge() {
    return allowedRechargeUsers.includes(this.props.currentUserId)
  }
}

export default WalletTransactionList



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/WalletTransactionList.tsx